module.exports = __webpack_public_path__ + "media/budapest/vajdahunyad_castle-d78712b1.jpg";